import React, { useState } from 'react'
import Meses from '../services/Meses';

export default function ListarNoticiasDestacadas(props) {

  const cores = ['b-success', 'b-primary', 'b-secondary', 'b-warning', 'b-danger', ' b-greensea', 'b-lightred'];
  const [meses, setMes] = useState(Meses);

  return (
    <>
      <section class="content page-calendar" style={{ marginTop: '-15px' }}>
        <div class="container-fluid">
          <br />
          <div class="card col-md-12" >
            <div class="block-header">
              <div class="row">
                <div class="col-lg-7 col-md-6 col-sm-12">
                  {props.children}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="body" style={{ marginTop: '-50px' }}>
                  {props.publicacoes.map((publicacao, i) =>
                    <>
                      <hr />
                      <div class={`event-name row ${cores[i]}`} onClick={() => props.handlePublicacao(publicacao)} data-toggle="modal" data-target="#largeModalPublicacao" style={{ cursor: 'pointer' }}>
                        <div class="col-1 text-center">
                          <h4>
                            {publicacao.data_publicacao && publicacao.data_publicacao.split('-')[2]}
                            <span>
                              {publicacao.data_publicacao && meses.filter(mes => mes.id == publicacao.data_publicacao.split('-')[1])[0].mes}
                            </span>
                            <span>{new Date(publicacao.data_publicacao).getFullYear()}</span>
                          </h4>
                        </div>
                        <div class="col-10" >
                          <h6 style={{ textTransform: 'none' }}>{publicacao.titulo}</h6>
                          <p>{publicacao.resumo}</p>
                          <address><i class="zmdi zmdi-mouse"></i> Clique para ler na integra </address>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}